import BaseApiError from './base'

class GenericApiError extends BaseApiError {
  readonly type = 'API_ERROR'
  readonly reason?: string
  readonly description?: string

  constructor(reason?: string, description?: string) {
    super()

    this.reason = reason
    this.description = description
  }
}

export default GenericApiError
